export default __webpack_public_path__ + "static/media/silhouette.bab31287.png";